import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
function ErrorText({ text, testId }) {
    if (!text || text.length === 0)
        return null;
    return (_jsx("span", { "data-test-id": `${testId ? testId + ':' : ''}ErrorText`, style: { color: 'var(--danger)', fontSize: 12, marginTop: 4, whiteSpace: 'break-spaces' }, children: text }));
}
export default React.memo(ErrorText);
